import type { Persona } from '../../console/_statics/persona.statics';
import { PERSONA_TYPES } from '../../console/_statics/persona.statics';
import { trimAndAddAsterisk } from '../../utility/QueryUtility';
import { applyQueryConfig, ServiceHandler } from '../../utils';
import { standardQuerySerializer } from '../serializers';

export const getAccounts = ServiceHandler({
  url: '/api/account/v1/account/search',
  paramsSerializer: (params) =>
    standardQuerySerializer(
      applyQueryConfig(
        [
          {
            path: 'search',
            transform: ({ search, searchValue }: any) => {
              if (searchValue) {
                return searchValue;
              }
              return search ? trimAndAddAsterisk(search) : null;
            },
          },
          { path: 'filter' },
        ],
        params
      )
    ),
});

export const getAccountDetails = ServiceHandler({
  url: '/api/account/v1/account/:persona',
});

export const getInsuredDetails = ServiceHandler({
  url: '/api/account/v1/account/:accountId',
});

/**
 * @name getAccountDetails
 * @description Works for all personas except "Cowbell", "Customer", "Digital Agg.",
 */
export const getAccount = async (persona: Persona, accountId?: string) => {
  if (persona === PERSONA_TYPES.CUSTOMER) {
    return getInsuredDetails(accountId as string);
  }

  return getAccountDetails(persona);
};

// Add OFAC check API function
export const getOfacCheck = ServiceHandler({
  url: '/api/account/v1/ofac-checks/account/:accountId',
});
